/*
 akhila 10/27/2022 2701251212  record format UX Changes
 */

import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import SubTabs from './SubTabsindex';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: '#296bff',
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function ReportMasterTabs({value, setValue}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <Typography />
      </div>
      <div className={classes.subContent}>{value === 0 && <SubTabs />}</div>
    </div>
  );
}
